import React from 'react';
import { Props } from './renderContent';
import TextBox from '../TextBox/TextBox';
import { FONT_SIZE } from '../TextBox/constants';

const Subtitle = ({ children, options }: Props) => React.createElement(TextBox, { children, options, bold: true, size: FONT_SIZE.MEDIUM });

export default Subtitle;